import { createBrowserRouter } from 'react-router-dom';
import { rootRouteObjects } from '../shared/router';

export const router = createBrowserRouter(rootRouteObjects);
